var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"incident-new-toolbar"},[_c('r-button-action',{attrs:{"icon":"arrow-left","title":"Назад"},on:{"click":_vm.returnButtonHandler}}),_c('user-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }